// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quiz-panel {
  background-color: #1e293b;
  border-radius: 16px;
  padding: 2.5rem 2rem;
  border: 1px solid #334155;
}

.quiz-cards-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 2rem;
}

.quiz-card {
  background-color: #0f172a;
  border: 1px solid #334155;
  border-radius: 12px;
  padding: 1.5rem;
}

.quiz-question {
  font-size: 1.05rem;
  font-weight: 600;
  color: #f8fafc;
  margin-bottom: 1rem;
}

.quiz-options {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.quiz-opt-btn {
  text-align: left;
  background-color: #1e293b;
  color: #cbd5e1;
  border: 1px solid #334155;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.95rem;
}

.quiz-opt-btn:hover:not(:disabled) {
  background-color: #273549;
  color: #f8fafc;
}

.quiz-opt-btn.selected {
  border-color: #38bdf8;
  background-color: rgba(56, 189, 248, 0.15);
  color: #38bdf8;
}

.quiz-opt-btn.is-correct {
  border-color: #22c55e;
  background-color: rgba(34, 197, 94, 0.18);
  color: #4ade80;
}

.quiz-opt-btn.is-wrong {
  border-color: #ef4444;
  background-color: rgba(239, 68, 68, 0.18);
  color: #f87171;
}

.quiz-explanation {
  margin-top: 0.85rem;
  font-size: 0.85rem;
  color: #94a3b8;
  background-color: rgba(255, 255, 255, 0.03);
  padding: 0.6rem 0.8rem;
  border-radius: 6px;
}

.quiz-actions {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
}

.quiz-submit-btn {
  background-color: #0284c7;
  color: #ffffff;
  border: none;
  padding: 0.8rem 1.8rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.quiz-submit-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.quiz-submit-btn:hover:not(:disabled) {
  background-color: #0369a1;
}

.quiz-result-banner {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  font-size: 1.15rem;
  font-weight: 700;
  color: #38bdf8;
}

.quiz-retry-btn {
  background-color: #334155;
  color: #f8fafc;
  border: none;
  padding: 0.5rem 1.2rem;
  font-size: 0.9rem;
  border-radius: 6px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/InteractiveQuiz.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,2CAA2C;EAC3C,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".quiz-panel {\n  background-color: #1e293b;\n  border-radius: 16px;\n  padding: 2.5rem 2rem;\n  border: 1px solid #334155;\n}\n\n.quiz-cards-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  margin-top: 2rem;\n}\n\n.quiz-card {\n  background-color: #0f172a;\n  border: 1px solid #334155;\n  border-radius: 12px;\n  padding: 1.5rem;\n}\n\n.quiz-question {\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: #f8fafc;\n  margin-bottom: 1rem;\n}\n\n.quiz-options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.quiz-opt-btn {\n  text-align: left;\n  background-color: #1e293b;\n  color: #cbd5e1;\n  border: 1px solid #334155;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 0.95rem;\n}\n\n.quiz-opt-btn:hover:not(:disabled) {\n  background-color: #273549;\n  color: #f8fafc;\n}\n\n.quiz-opt-btn.selected {\n  border-color: #38bdf8;\n  background-color: rgba(56, 189, 248, 0.15);\n  color: #38bdf8;\n}\n\n.quiz-opt-btn.is-correct {\n  border-color: #22c55e;\n  background-color: rgba(34, 197, 94, 0.18);\n  color: #4ade80;\n}\n\n.quiz-opt-btn.is-wrong {\n  border-color: #ef4444;\n  background-color: rgba(239, 68, 68, 0.18);\n  color: #f87171;\n}\n\n.quiz-explanation {\n  margin-top: 0.85rem;\n  font-size: 0.85rem;\n  color: #94a3b8;\n  background-color: rgba(255, 255, 255, 0.03);\n  padding: 0.6rem 0.8rem;\n  border-radius: 6px;\n}\n\n.quiz-actions {\n  margin-top: 2rem;\n  display: flex;\n  justify-content: center;\n}\n\n.quiz-submit-btn {\n  background-color: #0284c7;\n  color: #ffffff;\n  border: none;\n  padding: 0.8rem 1.8rem;\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.quiz-submit-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.quiz-submit-btn:hover:not(:disabled) {\n  background-color: #0369a1;\n}\n\n.quiz-result-banner {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #38bdf8;\n}\n\n.quiz-retry-btn {\n  background-color: #334155;\n  color: #f8fafc;\n  border: none;\n  padding: 0.5rem 1.2rem;\n  font-size: 0.9rem;\n  border-radius: 6px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
